// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DateEntityConfig__container___3YuzX{width:70%;margin:0 auto;margin-bottom:60px}.DateEntityConfig__title___2jdYL{font-size:20px;font-weight:600}.DateEntityConfig__subtitle___2qNXM{font-size:18px;font-weight:400}.DateEntityConfig__group___21un3{padding:10px 0px}.DateEntityConfig__head___1dOhw{font-size:16px;border-bottom:1px solid #e9e9e9;font-weight:500;margin-bottom:10px}.DateEntityConfig__row___3lEAV{display:flex}.DateEntityConfig__key___RbqIX{flex:1}.DateEntityConfig__value___cOtxY{flex:1}\n", ""]);
// Exports
exports.locals = {
	"container": "DateEntityConfig__container___3YuzX",
	"title": "DateEntityConfig__title___2jdYL",
	"subtitle": "DateEntityConfig__subtitle___2qNXM",
	"group": "DateEntityConfig__group___21un3",
	"head": "DateEntityConfig__head___1dOhw",
	"row": "DateEntityConfig__row___3lEAV",
	"key": "DateEntityConfig__key___RbqIX",
	"value": "DateEntityConfig__value___cOtxY"
};
module.exports = exports;
